import React, { useState } from "react";
import codeimage from "../../assets/codeimage.svg";
import codemessage from "../../assets/codemessgae.svg";
import closemodalicon from "../../../dashboard/assets/close-modal-icon.svg";
import facebookicon from "../../../dashboard/assets/facebook-icon.svg";
import twittericon from "../../../dashboard/assets/twitter-icon.svg";
import instagramicon from "../../../dashboard/assets/instagram-icon.svg";
import gmailicon from "../../../dashboard/assets/gmail-icon.svg";
import whatsappicon from "../../../dashboard/assets/whatsapp-icon.svg";
import pasteicon from "../../../dashboard/assets/paste-icon.svg";
import "./Referralcode.css";
import { Util } from "./../../../../../helpers/util";

const Referralcode = ({ referral_code }) => {
  const { currency } = Util.getCurrency();
  const [showRoiInfo, setShowRoiInfo] = useState(false);

  return (
    <div className="referral-code">
      <div>
        <div className="referral-page">
          <img src={codeimage} alt="" />
          <p className="referralParagraph">Invite & Earn {currency}2000</p>
          <p className="referralText">
            Invite a friend to join OVest and earn {currency}2000 as they sign
            up with your referral code and savest or invest.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            marginLeft: "51px",
            marginRight: "81px",
            marginTop: "35px",
          }}
        >
          <p
            style={{
              fontSize: "1.2rem",
            }}
          >
            Referral Code
          </p>
          <p
            style={{
              marginLeft: "29px",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "30px",
              marginTop: "-8px",
            }}
          >
            {referral_code}
          </p>
          <img
            src={codemessage}
            alt=""
            style={{
              marginLeft: "14px",
              marginTop: "-20px",
            }}
          />
        </div>
        <button
          className="referral-button"
          onClick={() => {
            setShowRoiInfo(true);
            console.log("hu");
          }}
        >
          Share
        </button>
      </div>
      <div
        className={`silverinvestment__roi-info-bg 
             ${showRoiInfo ? "show-roi-info" : ""}`}
      >
        <div className="invite-and-earn__roi-info-content">
          <div className="invite-and-earn-inner">
            <div className="closemodal-icon">
              <img
                src={closemodalicon}
                alt="close-modal"
                className="close-icon-btn"
                onClick={() => setShowRoiInfo(false)}
              />
            </div>
            <div className="invite-and-earn-section">
              <h5 className=" invite-header">Invite & Earn</h5>
              <p className="invite-and-earn-p mt-4">
                Share the code below, and earn when your friends sign up and
                invest on our app
              </p>
              <div className="input-referal mt-4">
                <p>{referral_code}</p>
                <div>
                  <img src={pasteicon} alt="" />
                  <span>copy code</span>
                </div>
              </div>
              <div className="social-media-icons mt-5">
                <img src={gmailicon} alt="" />
                <img src={facebookicon} alt="" />
                <img src={twittericon} alt="" />
                <img src={instagramicon} alt="" />
                <img src={whatsappicon} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Referralcode;
